import { z } from 'zod';
import { CLIENT_ORG_CONTEXT_INITIALS_ENUM } from './organizations.contracts';

export const pagingResourceSchema = z.object({
  page: z.number().int().gt(0),
  items: z.number().int().gte(0),
  total: z.number().int().gte(0),
  exactTotal: z.number().int().gte(0).optional(),
  softTotal: z.number().int().gte(0).optional(),
});
export type PagingResource = z.infer<typeof pagingResourceSchema>;

export const pagedResponseSchema = z.object({
  pagination: pagingResourceSchema,
});
export type PagedResponse = z.infer<typeof pagedResponseSchema>;

export const addressResourceSchema = z.object({
  street: z.string(),
  street2: z.string().optional(),
  city: z.string(),
  zip: z.string(),
  state: z.string(),
  stateCode: z.string(),
});
export type AddressResource = z.infer<typeof addressResourceSchema>;

export const visitTypeResourceSchema = z.object({
  name: z.string(),
  id: z.string(),
});
export type VisitTypeResource = z.infer<typeof visitTypeResourceSchema>;

export const availabilityResourceSchema = z.object({
  density: z.number().nullable(),
  slotsCount: z.number(),
});
export type AvailabilityResource = z.infer<typeof availabilityResourceSchema>;

export const pagedSearchCriteriaSchema = z.object({
  sort: z.string().optional(),
  page: z.number().int().gt(0),
  limit: z.number().int().gt(0),
});
export type PagedSearchCriteria = z.infer<typeof pagedSearchCriteriaSchema>;

export const nearBySearchCriteriaSchema = pagedSearchCriteriaSchema.extend({
  address: z.string().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  maxDistance: z.number().optional(),
  centerPoint: z.number().optional(),
});
export type NearBySearchCriteria = z.infer<typeof nearBySearchCriteriaSchema>;

export const entityNameResourceSchema = z.object({
  first: z.string(),
  middle: z.string(),
  last: z.string(),
  full: z.string(),
});
export type EntityNameResource = z.infer<typeof entityNameResourceSchema>;

export const urlResourceSchema = z.object({
  type: z.string(),
  value: z.string(),
});
export type UrlResource = z.infer<typeof urlResourceSchema>;

export const contactResourceSchema = z.object({
  type: z.string(),
  value: z.string(),
});
export type ContactResource = z.infer<typeof contactResourceSchema>;

export const coordinatesResourceSchema = z.object({
  lat: z.number(),
  lon: z.number(),
});
export type CoordinatesResource = z.infer<typeof coordinatesResourceSchema>;

export const hospitalAssociationsSchema = z.array(
  z.object({
    code: CLIENT_ORG_CONTEXT_INITIALS_ENUM,
    name: z.string(),
  }),
);
export type HospitalAssociationsResource = z.infer<
  typeof hospitalAssociationsSchema
>;
